var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BEFCA6F-AE8A-4586-89EC-8ACC93BD270A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---14---Compact-views",
    transform: "translate(-1300.000000, -205.000000)",
    fill: "#202020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(65.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(1172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(63.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,28 C0,29.1045695 0.8954305,30 2,30 L28,30 C29.1045695,30 30,29.1045695 30,28 L30,2 C30,0.8954305 29.1045695,0 28,0 Z M28,28 L2,28 L2,2 L28,2 L28,28 Z M7,16 L23,16 C23.5522847,16 24,15.5522847 24,15 C24,14.4477153 23.5522847,14 23,14 L7,14 C6.44771525,14 6,14.4477153 6,15 C6,15.5522847 6.44771525,16 7,16 Z M7,10 L23,10 C23.5522847,10 24,9.55228475 24,9 C24,8.44771525 23.5522847,8 23,8 L7,8 C6.44771525,8 6,8.44771525 6,9 C6,9.55228475 6.44771525,10 7,10 Z M7,22 L23,22 C23.5522847,22 24,21.5522847 24,21 C24,20.4477153 23.5522847,20 23,20 L7,20 C6.44771525,20 6,20.4477153 6,21 C6,21.5522847 6.44771525,22 7,22 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListInactive);
export default __webpack_public_path__ + "static/media/list-inactive.9a2f00435e5e90181c58c9d5261f65f2.svg";
export { ForwardRef as ReactComponent };